var pathSh = meta.page.pageType;
console.log("bayframes.......");
console.log("pathSh67789899", pathSh);
console.log("window.location.pathname", window.location.pathname);

console.log("pathSh", pathSh);
console.log("NEW SCRIPT LOADED");

if (pathSh == 'product') {
    console.log("123455");
    console.log("Shopify.locale_template");
    if (document.getElementsByTagName('livearf-variant-selects')[0]) {
        loadjscssfile("https://shop.livearf.com/lb4b-shop/dist/css/livevue-template.min.css", "css");
        // loadjscssfile("https://6af3-2409-40f4-4020-4ac8-d453-f9e1-a644-ffeb.ngrok-free.app/lb4b-shop/code/lb4b-shop/larf_preview/styles/livevue-template.css", "css")
        if (livevue_translate_data && livevue_translate_data.length > 0) {
            for (let i = 0; i < livevue_translate_data.length; i++) {
                if (document.querySelector('[data-trans-key="' + livevue_translate_data[i].key + '"]')) {
                    if (livevue_translate_data[i][Shopify.locale]) {
                        document.querySelector('[data-trans-key="' + livevue_translate_data[i].key + '"]').innerText = livevue_translate_data[i][Shopify.locale];
                    }
                }
            }
        }
        // tooltip
        document.querySelectorAll('.form-option-variant[title]').forEach(el => el.removeAttribute('title'));
        document.querySelectorAll('.form-option-variant img[title]').forEach(img => img.removeAttribute('title'));
        var tooltip = document.createElement("div");
        tooltip.className = "type_tooltip";
        document.body.appendChild(tooltip);
        var activeLabel = null;
        var canTap = true;
        var scrollTimeout;
        function showTooltipAtLabel(label, text) {
            var rect = label.getBoundingClientRect();
            var top = Math.max(0, rect.top - 10);
            var left = Math.min(window.innerWidth, rect.left + rect.width / 2);
            tooltip.innerText = text;
            tooltip.style.left = `${left}px`;
            tooltip.style.top = `${top}px`;
            tooltip.style.display = "block";
            tooltip.style.visibility = "visible";
            tooltip.style.opacity = "1";
        }
        function hideTooltip() {
            tooltip.style.visibility = "hidden";
            tooltip.style.opacity = "0";
            tooltip.style.display = "none";
            activeLabel = null;
        }
        function lockTapAfterScroll() {
            canTap = false;
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                canTap = true;
            }, 100);
        }
        if (document.querySelector('fieldset[name="Color"]')) {
            document.querySelector('fieldset[name="Color"]').addEventListener('click', function () {
                hideTooltip()
            })
        }
        document.querySelectorAll("fieldset").forEach(fieldset => {
            fieldset.querySelectorAll("input[type='radio'], input[type='checkbox']").forEach(input => {
                var tooltipText = input.getAttribute("data-tooltip");
                if (!tooltipText) return;
                var label = fieldset.querySelector(`label[for="${input.id}"]`);
                if (!label) return;
                label.addEventListener("click", () => {
                    if (activeLabel === label) return;
                    activeLabel = label;
                    showTooltipAtLabel(label, tooltipText);
                });
                label.addEventListener("mouseenter", () => {
                    if (window.innerWidth <= 900) return;
                    showTooltipAtLabel(label, tooltipText);
                });
                label.addEventListener("mouseleave", () => {
                    if (window.innerWidth <= 900) return;
                    hideTooltip();
                });
            });
        });
        window.addEventListener("scroll", () => {
            hideTooltip();
            lockTapAfterScroll();
        }, true);
        document.querySelectorAll("all-variant").forEach(container => {
            container.addEventListener("scroll", () => {
                hideTooltip();
                lockTapAfterScroll();
            }, true);
        });
        var parentElements = new Set([...document.querySelectorAll('input[action="frame"]')].map(input => input.parentElement));
        parentElements.forEach(function (fieldset, index) {
            // Hide only the frame names within frame fieldsets
            fieldset.querySelectorAll('.frameNames').forEach(el => {
                el.style.setProperty("display", "none", "important");
            });
            fieldset.querySelectorAll('input[action="frame"] + small, input[action="frame"] ~ small').forEach(el => {
                el.style.setProperty("display", "none", "important");
            });
            fieldset.querySelectorAll('.swatch_image').forEach(el => {
                el.style.height = '';
                el.style.width = '';
                el.style.padding = '4px !important';
                el.style.border = 'none';
            });
            fieldset.querySelectorAll('.swatchImage').forEach(el => {
                el.style.height = '100%';
                el.style.width = '100%';
            });
        });
        // Ensure non-frame small elements are visible
        document.querySelectorAll('livearf-variant-selects fieldset:not(:has(input[action="frame"])) small').forEach(el => {
            el.style.display = 'unset';
        });
        function mouseMovements(padding, bgColor, setValue, outlineValue) {
            mainFrameDiv.addEventListener('mouseenter', function () {
                if (mainFrameDiv.classList.contains('sideView')) {
                    this.style.setProperty('--d', setValue);
                    this.style.outline = `#0000004a solid ${outlineValue}`;
                    this.style.padding = padding;
                    this.style.backgroundColor = bgColor;
                }
            });
            mainFrameDiv.addEventListener('mouseleave', function () {
                this.style.removeProperty('--d');
                this.style.outline = 'none';
                this.style.padding = padding;
                this.style.backgroundColor = bgColor;
            });
        }
        function createLineDiv(className, height, marginTop) {
            let lineDiv = document.createElement('div');
            lineDiv.classList.add(className);
            lineDiv.style.height = height;
            lineDiv.style.display = 'block';
            lineDiv.style.backgroundColor = '#999999';
            lineDiv.style.marginTop = marginTop;
            lineDiv.style.zIndex = '4';
            lineDiv.style.textAlign = 'center';
            lineDiv.style.top = '0';
            lineDiv.style.fontSize = '11px';
            lineDiv.style.position = 'absolute';
            return lineDiv;
        }
        // Create image line div
        var imageDiv = document.querySelector('.mainFrameDiv');
        var imageLineDiv = createLineDiv('image-line', '1px', '-1.9em');
        console.log('imageLineDiv early', imageLineDiv);
        if (imageDiv) {
            imageDiv.parentNode.insertBefore(imageLineDiv, imageDiv);
        }
        // Create frame line div - FIX: Use a different variable name to avoid duplication
        var frameDivElement = document.querySelector('.mainFrameDiv');
        var isLineVisible = false;
        var imageLineFrameDiv = createLineDiv('frame-line', '1px', '-5.1em');
        if (frameDivElement) {
            frameDivElement.parentNode.insertBefore(imageLineFrameDiv, frameDivElement);
        }
        if (!document.querySelector('.frameProfileImage')) {
            var createframeProfileimage = document.createElement('li');
            createframeProfileimage.className = 'frameProfileImage animate';
            createframeProfileimage.style.display = 'inline-block';
            createframeProfileimage.style.cursor = 'pointer';
            createframeProfileimage.style.verticalAlign = 'middle';
            createframeProfileimage.style.marginLeft = '10px';
            var targetUl = document.querySelector('#previewIcons ul');
            if (targetUl) {
                targetUl.appendChild(createframeProfileimage);
            }
        }
        if (!document.getElementById('image-overlay')) {
            var overlay = document.createElement('div');
            overlay.id = 'image-overlay';
            overlay.className = 'livearf_overlay';
            overlay.innerHTML = `
                <span class="overlay-close-btn">&times;</span>
                <img id="overlay-image" src="" alt="Full image">
            `;
            document.body.appendChild(overlay);
            overlay.querySelector('.overlay-close-btn').addEventListener('click', () => {
                overlay.style.display = 'none';
            });
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) overlay.style.display = 'none';
            });
        }
        var productImagesCache = {};
        async function updateFrameProfileImage(element) {
            if (!element) return;
            var profileContainer = document.querySelector('.frameProfileImage');
            if (!profileContainer) return;
            var handle = element.getAttribute('data-linked_product_handle');
            var previewUrl = '';
            if (handle) {
                try {
                    if (productImagesCache[handle]) {
                        previewUrl = productImagesCache[handle];
                    } else {
                        let res = await fetch(`/products/${handle}.js`);
                        if (res.ok) {
                            let productData = await res.json();
                            if (productData.images && productData.images.length > 0) {
                                previewUrl = productData.images[2] || productData.images[0];
                                productImagesCache[handle] = previewUrl; // Cache image URL
                            }
                        }
                    }
                } catch (err) {
                    console.error("Error fetching product 3rd image:", err);
                }
            }
            if (!previewUrl) {
                previewUrl = element.getAttribute('data-preview-url') || element.getAttribute('data-frame-url');
            }
            if (previewUrl && previewUrl.startsWith('//')) {
                previewUrl = 'https:' + previewUrl;
            }
            if (!previewUrl || previewUrl === '' || previewUrl.includes('Liquid error')) {
                profileContainer.style.display = 'none';
            } else {
                profileContainer.innerHTML = `<img src="${previewUrl}" style="width:50px;height:50px;object-fit:cover;border-radius:4px;" alt="Frame Profile">`;
                profileContainer.style.display = 'inline-block';
                var imgEl = profileContainer.querySelector('img');
                if (imgEl) {
                    imgEl.addEventListener('click', function () {
                        var fullImageUrl = this.getAttribute('src');
                        var overlayImg = document.getElementById('overlay-image');
                        var overlay = document.getElementById('image-overlay');

                        if (fullImageUrl && overlayImg && overlay) {
                            overlayImg.src = fullImageUrl;
                            overlay.style.display = 'flex';
                        }
                    });
                }
            }
        }
        function createLabel(text) {
            const span = document.createElement("span");
            span.textContent = text;
            span.style.position = "absolute";
            span.style.top = "-20px";
            span.style.left = "50%";
            span.style.transform = "translate(-50%,0)";
            span.style.color = "black";
            return span;
        }
        var params = new URLSearchParams(window.location.search);
        var frameID = params.get("frameId");
        console.log("frameId initially in product page:", frameID);
        // initial UI setup based on product tags
        var imageText = document.querySelector('#imageQualitywarningNote');
        var matchedFg_frameOnly;
        var productTag = document.getElementsByClassName('livearf-product-tags')[0].getAttribute("data-tags");
        if (productTag == "Framed Canvas") {
            // if (frameDivElement) {
            //     frameDivElement.classList.add('sideView');
            // }
        } else if (productTag == "Frame Only") {
            var colorInput = document.querySelector('input[option_name="Color"]');
            frameGroup_Fs = colorInput ? colorInput.parentElement : null;
            var matStyleInput = document.querySelector('input[action="1st-mat-style"]');
            var legendElement = matStyleInput?.parentElement?.querySelector('legend');
            if (legendElement) {
                legendElement.innerHTML = `Mat Color <span style="color: red;">(Choose a Mat Color)</span>`;
            }
            if (frameID) {
                console.log("frameID:", frameID);
                // Find the matching frame using data-option-value-id
                var matchingInput = document.querySelector(
                    `input[data-linked_product_id]="${frameID}"]`
                );
                console.log("matchingInput:", matchingInput);
                if (matchingInput) {
                    var matchedFg_frameOnly = matchingInput.getAttribute("option_name");
                    console.log("matchedFg_frameOnly:", matchedFg_frameOnly);
                    // Select the Color group
                    document.querySelector(
                        `input[value="${matchedFg_frameOnly}"][action="none"]`
                    )?.click();
                    // Select the frame option
                    document.querySelectorAll(
                        `input[data-option-value-id="${frameID}"]`
                    ).forEach(input => {
                        input.click();
                        input.checked = true;
                    });
                } else {
                    console.log("No matching frame found for:", frameID);
                    // Default Black frame
                    document.querySelector('input[value="Black"]')?.click();
                }
            } else {
                console.log("No frameID found, selecting Black");
                document.querySelector('input[value="Black"]')?.click();
            }
            // Show Size fieldset
            document.querySelector('fieldset[name="Size"]')?.style.setProperty("display", "block");
            isLineVisible = true;
        } else if (productTag == "Print Only" || productTag == "Print and Frame") {
            if (productTag == "Print and Frame") {
                isLineVisible = true;
                var matStyleInput2 = document.querySelector('input[action="1st-mat-style"]');
                var legendElement2 = matStyleInput2?.parentElement?.querySelector('legend');
                if (legendElement2) {
                    legendElement2.innerHTML = `Mat Color <span style="color: red;">(Choose a Mat Color)</span>`;
                }
            }
        }
        // Initialize submitButtons before using it
        var submitButtons = document.querySelectorAll('[name="add"]');
        if (document.getElementsByClassName('uploadYourImage')[0]) {
            console.log("Image Upload Enabled");
            livevueImgUpload = true;
            var orgImageUrl;
            var croppedImgUrl;
            document.getElementById("editButton").childNodes[0].nodeValue = "Crop";
            if (!croppedData.originalImage) {
                console.log("No image uploaded yet");
                if (imageText) {
                    imageText.style.display = 'block';
                    imageText.style.marginTop = '1.5em';
                    imageText.style.color = 'red';
                    imageText.innerHTML = '<strong>Note: </strong>Please upload your image here...';
                }
                // Re-query to ensure we have the latest buttons
                submitButtons = document.querySelectorAll('[name="add"]');
                submitButtons.forEach(button => {
                    button.style.pointerEvents = 'none';
                    button.style.opacity = '0.5';
                    button.style.cursor = 'not-allowed';
                });
            }
        }
        if (larf_flow) {
            console.log("linked_components:", linked_components);
            const pricingData = [];
            const allOptions = Array.isArray(linked_components)
                ? linked_components.flatMap(c =>
                    Array.isArray(c?.options) ? c.options : []
                )
                : [];
            if (allOptions.length) {
                console.log("allOptions:", allOptions);
                allOptions.forEach((opt, index) => {
                    console.log("========== OPTION", index, "==========");
                    console.log(opt);
                    console.log("Name:", opt.name);
                    console.log("Label:", opt.label);
                    console.log("Price Type:", opt.price_type);
                });
                pricingData.push(
                    ...allOptions.flatMap(opt =>
                        (Array.isArray(opt?.option_values) ? opt.option_values : []).map(v => ({
                            option_value_id: v.id,
                            overall_size: opt.pricing_classification_basis === "overall-size",
                            include_in_frame_size: v.include_in_frame_size || false,
                            pricing_v2: Array.isArray(v.pricing_v2) ? v.pricing_v2 : []
                            //predefined_price: v.predefined_price
                        }))
                    )
                );
            }
            var variantId;
            var larfPrice;
            var dataObject = [];
            var livevueImgUpload = false;
            var orderImage;
            var originalImage;
            let variantRemoved = false;
            var selectedOptions;
            var roomPreview = false;
            var isFloater = false;
            var isCanvasFrame = false;
            var productTag = document.getElementsByClassName('livearf-product-tags')[0].getAttribute("data-tags");
            //var imageText = document.querySelector('#imageQualitywarningNote');
            var shopUniqueId = Shopify.shop.replace(".myshopify.com", "_myshopify");
            var priceElement = document.createElement('span');
            priceElement.className = "livevue-display-price";
            priceElement.innerHTML = document.querySelector('#larf-display-price').innerText;
            var discountElement = document.createElement('span');
            discountElement.className = "livevue-discount-price";
            discountElement.style.display = 'none';
            discountElement.style.marginLeft = "1rem";
            discountElement.innerHTML = document.querySelector('#larf-display-price').innerText;
            var salebanner = document.createElement('span');
            salebanner.className = "livevue-sale-banner badge price__badge-sale color-scheme-4";
            salebanner.innerHTML = "Sale";
            salebanner.style.marginLeft = "1rem";
            salebanner.style.display = "none";
            var placeElement = document.querySelector('#larf-display-price');
            if (placeElement) {
                placeElement.insertAdjacentElement('afterend', salebanner);
                placeElement.insertAdjacentElement('afterend', discountElement);
                placeElement.insertAdjacentElement('afterend', priceElement);
                placeElement.style.display = 'none';
            }
            const cartMessages = livevue_settings?.settings?.addtoCart?.texts || [{ "value": "Adding to Cart" }];
            var cartPageLoader = document.createElement('div');
            cartPageLoader.id = 'larfloader';
            cartPageLoader.innerHTML = `<div class="loader-spinner"><p></p></div><div class="loader-text">${cartMessages[0]?.value}</div>`;
            const loaderText = cartPageLoader.querySelector(".loader-text");
            document.querySelector('body').append(cartPageLoader);
            var allProperties;
            if (document.getElementsByClassName('uploadYourImage')[0]) {
                livevueImgUpload = true;
            }
            const threeDView = document.querySelector('#threeDView');
            const frameView = document.querySelector('#frameView');
            // roomview clicked event for framed canvas product
            document.querySelectorAll('#roomView, #frameView').forEach(function (element) {
                element.addEventListener('click', function () {
                    roomPreview = element.id === 'roomView';
                    let roomOptions = {
                        type: 'previewIcons',
                        value: element.id,
                        isRoom: roomPreview,
                    }
                    setTimeout(() => {
                        document.querySelector('#draggableContainer').style.backgroundColor = '#606a6b';
                        document.querySelector('.mainFrameDiv').style.backgroundColor = '#606a6b';
                    }, 200);
                    //optionChangingfn(roomOptions)
                });
            });
            const normalizeSize = (str = '') => {// Normalize size: "12 x 18" === "18 x 12"
                const nums = str.match(/\d+/g)?.map(Number);
                return nums?.length === 2 ? nums.sort((a, b) => a - b).join(' x ') : '';
            };
            const isInRange = (range, value) => {
                const [min, max] = range.split("-").map(Number);
                return value >= min && value <= max;
            };
            const getEffectiveSize = (overallSize = false) => {
                const width = Number(currentSize.width);
                const height = Number(currentSize.height);
                if (!overallSize) {
                    return { width, height };
                }
                const frame = Number(currentSize.frameThickness || 0);
                const firstMat = Number(currentSize.firstMatSize || 0);
                const secondMat = Number(currentSize.secondMatSize || 0);
                const extra = 2 * (frame + firstMat + secondMat);
                return { width: width + extra, height: height + extra, };
            };
            const getPredefinedPriceV2 = (predefinedPrice = [], rule = {}, overallSize = false) => {
                const priceType = rule.price_type || '';
                if (!Array.isArray(predefinedPrice)) {
                    return {
                        price: 0,
                        calculation_type: 'fixed-price'
                    };
                }
                let price = 0;
                let calculation_type = 'fixed-price';
                let match = null;
                if (priceType.startsWith('predefined-')) {
                    const inputSize = normalizeSize(`${currentSize.width} x ${currentSize.height}`);
                    const match = predefinedPrice.find(item => normalizeSize(item.value) === inputSize);
                    price = Number(match?.price || 0);
                    calculation_type = priceType.replace('predefined-', '');
                } else if (priceType.includes('range')) {
                    const { width, height } = getEffectiveSize(overallSize);
                    let compareValue = 0;

                    if (rule.calculation_type?.includes('surface')) {
                        compareValue = width * height;
                    } else if (rule.calculation_type === 'perimeter') {
                        compareValue = 2 * (width + height);
                    } else if (rule.calculation_type === 'linear_max' || priceType === 'range-size_fixed-price') {
                        compareValue = Math.max(width, height);
                    } else {
                        compareValue = width + height;
                    }
                    match = predefinedPrice.find(item =>
                        isInRange(item.value || item.range, compareValue)
                    );
                    price = Number(match?.price || 0);
                    if (priceType.includes('ranged')) {
                        calculation_type = 'fixed-price';
                    } else if (priceType === 'range-size_fixed-price') {
                        calculation_type = 'fixed-price';
                    } else if (priceType === 'range-size_unit-price') {
                        calculation_type = rule.calculation_type;
                    }
                }
                return { price, calculation_type, range: match?.range || '' };
            };
            function getSelectedData(event) {
                console.log("selectedData");
                console.log("starting.....");
                const el = event?.target;
                var selectedOptionName = '';
                var selectedValue = '';
                if (el) {
                    const source = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
                    selectedOptionName = source?.getAttribute('option_name') || '';
                    selectedValue = source?.getAttribute('value') || '';
                }
                let action = el?.getAttribute('action');
                if ((action === 'frame' || action === 'floater-frame') && el) {
                    handle3dIconVisible(el);
                    console.log('calling update frame profile image 1')
                    updateFrameProfileImage(el);
                }
                dataObject = [];
                const selectedElements = document.querySelectorAll(
                    'all-variant input:checked, all-variant select'
                );
                console.log("selectedElements", selectedElements);
                console.log("Selected count:", selectedElements.length);
                if (["Print and Frame", "Frame Only"].includes(productTag)) {
                    var imageDiv = document.querySelector('#frameViewCanvas');
                    console.log('imageDiv', imageDiv);
                    var imageLineDiv = document.querySelector('.image-line');
                    var frameDiv = document.querySelector('.mainFrameDiv');
                    var frameLineDiv = document.querySelector('.frame-line');
                    // Only proceed if all elements exist
                    if (imageDiv && imageLineDiv && frameDiv && frameLineDiv) {
                        if (productTag == "Frame Only" && selectedOptionName == 'Color') {
                            if (selectedValue != matchedFg_frameOnly) {
                                let frameIcon = document.querySelector(`input[option_name="${selectedValue}"][action="frame"]`);
                                if (frameIcon && !frameIcon.checked) {
                                    frameIcon.click();
                                }
                            }
                        }
                        if (productTag === "Print and Frame" && selectedOptionName == 'Color' && selectedValue) {
                            let frameIcon = document.querySelector(`input[option_name="${selectedValue}"][action="frame"]`);
                            if (frameIcon && !frameIcon.checked) {
                                frameIcon.click();
                            }
                        }
                        if (isLineVisible) {
                            var frameWidth = parseFloat(frameDiv.style.borderWidth) || 0;
                            var targetMatSize = parseFloat(document.querySelector('input[action="1st-mat-size"]:checked')?.value) || 0;
                            const offsetParent = imageLineDiv.offsetParent || frameDiv.offsetParent || imageLineDiv.parentElement;
                            const parentRect = offsetParent.getBoundingClientRect();
                            const imageLeft = imageDiv.getBoundingClientRect().left - parentRect.left;
                            const frameLeft = frameDiv.getBoundingClientRect().left - parentRect.left;
                            imageLineDiv.style.width = `${imageDiv.offsetWidth - 10}px`;
                            imageLineDiv.style.left = `${imageLeft + 5}px`;
                            imageLineDiv.innerHTML = "";
                            //imageLineDiv.appendChild(createLabel("Image Size"));
                            imageLineDiv.append(`${currentSize.width} inches`);
                            imageLineDiv.style.display = "block";
                            frameLineDiv.style.width = `${frameDiv.offsetWidth - 2 * frameWidth}px`;
                            frameLineDiv.style.left = `${frameLeft + frameWidth}px`;
                            frameLineDiv.innerHTML = "";
                            //frameLineDiv.appendChild(createLabel("Outer Frame Size"));
                            frameLineDiv.append(`${currentSize.width + 2 * targetMatSize} inches`);
                            frameLineDiv.style.display = "block";
                        }
                    }
                }
                // option change for Framed canvas product tag
                // if (productTag == "Framed Canvas") {
                //     let frameGroupIcon = document.querySelector(`input[option_name="Color"][action="none"]`);
                //      console.log("frameGroupIcon",frameGroupIcon);
                //     if (selectedValue === "Framed") {
                //         console.log("Framed selected");
                //         isFloater = false;
                //         isCanvasFrame = true;
                //         if (frameGroupIcon && !frameGroupIcon.checked) {
                //             frameGroupIcon.click();
                //         }
                //         // Wait until frame options are ready
                //         setTimeout(() => {
                //             const defaultFrame = document.querySelector(
                //                 'input[action="frame"][value="Burgundy-1"]'
                //             );
                //             console.log("defaultFrame", defaultFrame);
                //             if (defaultFrame) {
                //                 defaultFrame.checked = true;
                //                 defaultFrame.dispatchEvent(new Event("change", {
                //                     bubbles: true
                //                 }));
                //                 defaultFrame.click();
                //             }
                //         }, 200);
                //     } else if (selectedValue === "Floater Frames") {
                //         isFloater = true;
                //         isCanvasFrame = false;
                //         if (frameGroupIcon && !frameGroupIcon.checked) {
                //             frameGroupIcon.click();
                //         }
                //     } 
                //     else if (selectedValue === "Gallery Wrap") {
                //         isFloater = false;
                //         isCanvasFrame = false;
                //     }
                //     if (isFloater || isCanvasFrame) {
                //         var container = roomPreview ? draggableContainer : mainFrameDiv;
                //         var styleConfig = {
                //             padding: isFloater ? (roomPreview ? '2px' : '8px') : '',
                //             backgroundColor: '#606a6b',
                //         };
                //         Object.assign(container.style, styleConfig);
                //         if (!roomPreview) {
                //             var mouseConfig = isFloater ? ['8px', '#606a6b', '20px', '20px'] : ['', '#606a6b', '5px', '5px'];
                //             mouseMovements(...mouseConfig);
                //         }
                //     } else {
                //         var container = roomPreview ? draggableContainer : mainFrameDiv;
                //         Object.assign(container.style, { padding: '', backgroundColor: '#606a6b', border: '' });
                //         if (!roomPreview) {
                //             mouseMovements('', '#606a6b', '15px', '15px');
                //         }
                //     }
                // }
                selectedElements.forEach(el => {
                    const source = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
                    console.log('source', source);
                    if (!source) return;
                    console.log("Selected option:", source.getAttribute("option_name"));
                    console.log("Selected value:", source.getAttribute("value"));
                    const optionValueId = source.getAttribute('data-option-value-id');
                    console.log("optionvalueID", optionValueId);
                    if (!optionValueId) return;
                    pricingData.filter(item => item.option_value_id === optionValueId).forEach(item => {
                        console.log("Current Item", item);
                        const matchedRules = item.pricing_v2.filter(priceRule => {
                            if (!priceRule.price_type?.includes('exact-size')) {
                                return true;
                            }
                            const currentWidth = Number(currentSize.width);
                            const currentHeight = Number(currentSize.height);
                            const ruleWidth = Number(priceRule.width);
                            const ruleLength = Number(priceRule.length);
                            return (
                                (currentWidth === ruleWidth && currentHeight === ruleLength) ||
                                (currentWidth === ruleLength && currentHeight === ruleWidth)
                            );
                        });
                        const isRangePricing = matchedRules.some(rule => rule.price_type?.includes('range'));
                        if (isRangePricing) {
                            const pricing = getPredefinedPriceV2(matchedRules, matchedRules[0], item.overall_size);
                            dataObject.push({
                                id: optionValueId,
                                overall_size: item.overall_size,
                                include_in_frame_size: item.include_in_frame_size,
                                price_type: matchedRules[0].price_type,
                                unit: matchedRules[0].unit,
                                length: '',
                                width: '',
                                range: pricing.range,
                                calculation_unit: matchedRules[0].calculation_unit,
                                ...pricing
                            });
                        } else {
                            // FIX: Remove duplicates by using a Set or checking if ID already exists
                            matchedRules.forEach(priceRule => {
                                // Check if this ID already exists in dataObject
                                const exists = dataObject.some(item => item.id === optionValueId);
                                if (!exists) {
                                    const pricing = priceRule.price_type.includes("predefined")
                                        ? getPredefinedPriceV2(item.pricing_v2, priceRule, item.overall_size)
                                        : {
                                            price: Number(priceRule.price || 0),
                                            calculation_type: priceRule.calculation_type
                                        };
                                    dataObject.push({
                                        id: optionValueId,
                                        overall_size: item.overall_size,
                                        include_in_frame_size: item.include_in_frame_size,
                                        price_type: priceRule.price_type,
                                        unit: priceRule.unit,
                                        length: priceRule.length,
                                        width: priceRule.width,
                                        range: priceRule.range,
                                        calculation_unit: priceRule.calculation_unit,
                                        ...pricing
                                    });
                                }
                            });
                        }
                    });
                });
                var activeFrame = document.querySelector('input[action="frame"]:checked');
                if (activeFrame) updateFrameProfileImage(activeFrame);
                pricingCalculation(dataObject);
            }
            const getCheckedValue = selector => parseFloat(document.querySelector(selector)?.value) || 0;

            function pricingCalculation(selectedData = []) {
                console.log("pricingdata.....");
                // const surfaceCalValue = currentSize.unit === 'cm' ? 10000 : currentSize.unit === 'mm' ? 1 : 144;
                // const circumferenceCalValue = currentSize.unit === 'cm' ? 100 : currentSize.unit === 'mm' ? 1 : 12;
                const discount = getCheckedValue('[action="discount"]:checked');
                const markup = getCheckedValue('[action="markup"]:checked');
                const margin = getCheckedValue('[action="margin"]:checked');
                const width = Number(currentSize.width);
                const height = Number(currentSize.height);
                const surfaceArea = (width * height) / 10000;
                const circumference = 2 * ((width + height) / 100);
                const linerUnit = width + height;
                let finalPrice = selectedData.reduce((total, item) => {
                    const { price, calculation_type, price_type, length: ruleLength, width: ruleWidth, unit } = item;
                    if (!price) return total;
                    const { width: currentWidth, height: currentHeight } = getEffectiveSize(item.overall_size);
                    const type = calculation_type || 'fixed-price';
                    let value = 0;
                    const exactLinearLW = Number(ruleLength || 0) + Number(ruleWidth || 0);
                    const exactLinearMax = Math.max(Number(ruleLength || 0), Number(ruleWidth || 0));
                    const exactPerimeter = 2 * (Number(ruleLength || 0) + Number(ruleWidth || 0));
                    let exactSurfaceArea = Number(ruleLength || 0) * Number(ruleWidth || 0);
                    const currentLinearLW = currentWidth + currentHeight;
                    const currentLinearMax = Math.max(currentWidth, currentHeight);
                    const currentPerimeter = 2 * (currentWidth + currentHeight);
                    let currentSurfaceArea = currentWidth * currentHeight;
                    const surfaceFactor = unit === 'in' ? 144 : unit === 'cm' ? 10000 : unit === 'mm' ? 1000000 : 1;
                    exactSurfaceArea /= surfaceFactor;
                    currentSurfaceArea /= surfaceFactor;

                    const isExactSize = price_type?.includes('exact-size');
                    switch (true) {
                        case type === 'linear_max': value = price * (isExactSize ? exactLinearMax : currentLinearMax);
                            console.log("Linear Max Price Calculation:", value);
                            break;
                        case type?.includes('linear'): value = price * (isExactSize ? exactLinearLW : currentLinearLW);
                            console.log("Linear Price Calculation:", value);
                            break;
                        case type === 'perimeter': value = price * (isExactSize ? exactPerimeter : currentPerimeter);
                            console.log("Perimeter Price Calculation:", value);
                            break;
                        case type?.includes('surface'): value = price * (isExactSize ? exactSurfaceArea : currentSurfaceArea);
                            console.log("Surface Price Calculation:", value);
                            break;
                        case type === 'fixed-price':
                            console.log("Fixed Price Calculation:", price);
                        default:
                            value = price;
                            break;
                    }
                    return total + value;
                }, 0);
                //Base variant price
                variantId = document.querySelector('.product-variant-id')?.value;
                console.log("Final Price:", finalPrice);
                console.log("Variant ID:", variantId);
                const variant = product_variants.find(v => v.id == variantId);
                if (variant) finalPrice += variant.price / 100;
                // console.log("Variant Price:", variant.price);
                // console.log("Final Price after Variant:", finalPrice);
                // Apply markup & margin
                if (markup) finalPrice *= 1 + markup / 100;
                if (margin) finalPrice /= 1 - margin / 100;
                const basePriceText =
                    document.getElementById('larf-display-price')?.innerText || '';
                // Discount UI
                if (discount) {
                    console.log("Discount:", discount);
                    const discountedPrice = finalPrice * (1 - discount / 100);
                    document.querySelector('.livevue-display-price').style.textDecoration = 'line-through';
                    document.querySelector('.livevue-discount-price').style.display = 'inline-block';
                    document.querySelector('.livevue-sale-banner').style.display = 'inline-block';
                    document.querySelector('.livevue-discount-price').innerText = moneyWithCurrency(basePriceText, discountedPrice);
                }
                larfPrice = finalPrice;
                // Final price display
                document.querySelector('.livevue-display-price').innerText = moneyWithCurrency(basePriceText, finalPrice);
                // Add to cart toggle
                document.querySelector('[name="add"]').disabled = finalPrice === 0;
            }
            async function checkOrderJson(optionName) {
                const targetPrice = Number(larfPrice).toFixed(2);
                for (const product of orderJson || []) {
                    const variant = product.variants?.find(
                        v => v.variant_title === optionName
                    );
                    if (variant) {
                        return {
                            variantId: variant.variant_id,
                            isVariant: true,
                            priceNeedsUpdate: variant.variant_price != targetPrice,
                            order_productId: product.order_product_id
                        };
                    }
                }
                return { variantId: undefined, isVariant: false, priceNeedsUpdate: false };
            }
            function handle3dIconVisible(el) {
                if (!threeDView) return;
                const selectedItem = document.querySelector('#previewIcons li.selected');
                const hasProfile = el.getAttribute('profile-id')?.trim();
                const shouldHide = !hasProfile;
                threeDView?.classList.toggle('hideBlock', shouldHide);
                if (shouldHide && selectedItem?.id === 'threeDView') {
                    frameView?.click();
                }
            }
            async function getOrderProperties1() {
                console.log("getOrderProperties1.....");
                const jsonObject = {}
                const selectedVelues = document.querySelectorAll(
                    ':is(livearf-variant-selects, variant-selects) fieldset.rule_visible input:checked, ' +
                    ':is(livearf-variant-selects, variant-selects) fieldset:not(.hideBlock) input:checked, ' +
                    ':is(livearf-variant-selects, variant-selects) fieldset:not(.rule_hidden) input[type="number"]'
                );
                for (const each of selectedVelues) {
                    console.log("Processing element:", each);
                    if (each.getAttribute('action') != 'discount' && each.getAttribute('action') != 'markup' && each.getAttribute('action') != 'margin') {
                        const optionName = each?.parentNode?.querySelector('legend')?.innerText || each.labels[0].innerText;
                        const optionValue = each?.value || each?.labels[0]?.querySelector('small')?.innerText;
                        jsonObject[optionName] = optionValue;
                    }
                }
                if (croppedData.originalImage) {
                    jsonObject["Original Image"] = croppedData.originalImage;
                    jsonObject["Cropped Image"] = getCroppedImage();
                }
                return jsonObject;
            }
            document.querySelectorAll('all-variant input, all-variant select')
                .forEach(el => el.addEventListener('change', getSelectedData)); // change function
            setTimeout(() => {
                getSelectedData();// onload
                //updateDimensionLines();
            }, 500);
            setTimeout(() => {
                const selectedProductId = localStorage.getItem("selectedProductId");
                if (!selectedProductId) return;
                console.log("selectedProductId:", selectedProductId);
                // Find the frame input initially
                let matchingInput = [...document.querySelectorAll('input[action="frame"]')]
                    .find(input =>
                        input.getAttribute("data-linked_product_id") === selectedProductId
                    );
                console.log("Initial matchingInput:", matchingInput);
                if (!matchingInput) return;

                const optionName = matchingInput.getAttribute("option_name");
                console.log("optionName:", optionName);
                // Select Color
                const colorInput = [...document.querySelectorAll('input[option_name="Color"]')]
                    .find(input => input.value === optionName);
                console.log("colorInput:", colorInput);
                if (colorInput) {
                    colorInput.click();
                    // Wait for Color selection to update/re-render frame options
                    setTimeout(() => {
                        // Find the frame input AGAIN after Color change
                        matchingInput = [...document.querySelectorAll('input[action="frame"]')]
                            .find(input =>
                                input.getAttribute("data-linked_product_id") === selectedProductId
                            );
                        console.log("Matching frame after color:", matchingInput);
                        if (!matchingInput) return;
                        matchingInput.click();
                        matchingInput.checked = true;
                        console.log("Clicked matching input:", matchingInput);
                        // Remove after successful selection
                        //localStorage.removeItem("selectedProductId");
                    }, 300);
                }
            }, 300);
            if (frameSelling == 'preview-only') {
                console.log("Frame is for preview only");
                var lb4bNote = document.createElement('div');
                lb4bNote.className = 'preview-only';
                lb4bNote.innerHTML = `<span class="lb4-note" style="color:red"><font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">(Note: Frames are available for preview purposes only.</font></font><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">)</font></font></span>`;
                var addToCartButton = document.querySelector('[name="add"]');
                if (addToCartButton) {
                    addToCartButton.parentNode.insertBefore(lb4bNote, addToCartButton);
                }
            }
            if (frameSelling == 'for-sale') {
                console.log("Frame is for sale");
                document.querySelector('[name=add]').addEventListener('click', async function (e) {
                    e.preventDefault();
                    document.getElementById('frameView').click();
                    document.getElementById('larfloader').style.display = 'flex';
                    let index = 1;
                    let interval = (Number(livevue_settings?.settings?.addtoCart?.settings?.loader_message_interval) ?? 2) * 1000;
                    messageInterval = setInterval(() => {
                        loaderText.textContent = cartMessages[index]?.value;
                        index = (index + 1) % cartMessages.length;
                    }, interval);
                    allProperties = await getOrderProperties1();
                    cloneElementForScreenShot();
                });
            }
            //clone element function for screenShot.
            function cloneElementForScreenShot() {
                var existingClonedDiv = document.getElementById('newPreviewArea');
                if (existingClonedDiv) existingClonedDiv.remove();
                var originalDiv = document.querySelector('.main-previewArea');
                if (!originalDiv) return;
                var clonedDiv = originalDiv.cloneNode(true);
                clonedDiv.id = 'newPreviewArea';
                clonedDiv.classList.add('new' + originalDiv.classList[1]);
                var mainFrame = document.querySelector('.mainimageDiv');
                if (!mainFrame) return;
                var newMainFrameDiv = clonedDiv.querySelector('.mainFrameDiv');
                var newMainImageDiv = clonedDiv.querySelector('.mainimageDiv');
                if (!newMainFrameDiv || !newMainImageDiv) return;
                newMainFrameDiv.classList.add('new' + newMainFrameDiv.classList[0]);
                newMainFrameDiv.style.width = `${mainFrame.offsetWidth}px`;
                newMainImageDiv.classList.add('new' + newMainImageDiv.classList[0]);
                var imageElement = document.createElement('img');
                imageElement.className = "newimage-magnify-lightbox";
                imageElement.style.width = document.querySelector('#frameViewCanvas')?.offsetWidth + 'px';
                imageElement.style.height = document.querySelector('#frameViewCanvas')?.offsetHeight + 'px';
                livevueImgUpload ? imageElement.src = allProperties["Cropped Image"].replace('.png', '.jpeg') : imageElement.src = mainImage.src;
                newMainImageDiv.appendChild(imageElement);
                originalDiv.parentNode.appendChild(clonedDiv);
                clonedDiv.style.display = 'none';
                var canvasElement = clonedDiv.querySelector('.newmainFrameDiv canvas');
                if (canvasElement) canvasElement.remove();
                orderProperties();
            }
            async function orderProperties() {
                var variant_Data = {};
                let optionName = Object.values(allProperties)
                    .filter(val => typeof val === "string" && !val.includes("https"))
                    .join("/");
                if (livevueImgUpload) {
                    variant_Data.original_image = croppedData.originalImage;
                    orderImage = allProperties["Cropped Image"].replace('.png', '.jpeg');
                } else {
                    var checkOrder = await checkOrderJson(optionName);
                    orderImage = mainImage.src;
                }
                allProperties["_source"] = document.querySelector('[property="og:url"]').getAttribute('content');
                for (const key of ["livevue_orderImage", "livevue_frameStyles"]) {
                    localStorage.removeItem(key);
                }
                localStorage.setItem("livevue_orderImage", orderImage);
                let frameStyles = document.querySelector(".mainFrameDiv")?.getAttribute("style") || "";
                localStorage.setItem("livevue_frameStyles", frameStyles);
                let matStyles = document.querySelector(".mainimageDiv")?.getAttribute("style") || "";
                localStorage.setItem("livevue_matStyles", matStyles);
                variant_Data.variant_data = dataObject;
                console.log('variant_Data', variant_Data)
                variant_Data.option_name = "Combination",
                console.log('optionName', optionName)
                variant_Data.option_value = optionName,
                console.log('optionValue', variant_Data.option_value);
                variant_Data.variant_id = variantId;
                console.log('variantId', variantId)
                variant_Data.width = currentSize.width;
                console.log('width', currentSize.width)
                variant_Data.height = currentSize.height;
                console.log('height', currentSize.height)
                variant_Data.shop_domain = Shopify.shop;
                console.log('shop_domain', Shopify.shop)
                variant_Data.unit = currentSize.unit;
                console.log('unit', currentSize.unit)
                variant_Data.app_name = 'larfsh';
                variant_Data.plt_prod_id = meta.product.id;
                variant_Data.plt_prod_name = document.querySelector('[property="og:title"]').content;
                variant_Data.image_upload = livevueImgUpload;
                variant_Data.html_element = document.querySelector('.newmainFrameDiv')?.outerHTML;
                if (!livevueImgUpload && checkOrder?.isVariant) {
                    const url = `/variants/${checkOrder.variantId}.json`;
                    let response = await fetch(url);
                    if (!response.ok) {
                        variantRemoved = true;
                    }
                }
                if (!variantRemoved && !livevueImgUpload && checkOrder.isVariant && !checkOrder.priceNeedsUpdate) {
                    console.log('priceNO Needs to Update', variant_Data)
                    result = { variantid: checkOrder.variantId }
                } else {
                    console.log('priceNeedsUpdate', variant_Data)
                    if (!variantRemoved && !livevueImgUpload && checkOrder.priceNeedsUpdate) {
                        variant_Data.variant_update_data = {}
                        variant_Data.variant_update_data.variant_id = checkOrder.variantId;
                        variant_Data.variant_update_data.product_id = checkOrder.order_productId;
                    }
                    let response = await fetch(`/apps/ShopAuth/cartPagePricingV5`, {
                        method: 'POST',
                        body: JSON.stringify(variant_Data)    
                    });
                    console.log("Status:", response.status);
                    //const text = await response.text();
                    //console.log("Response:", text);
                    if (!response.ok) {
                        throw new Error('Failed to fetch cart page pricing');
                    }
                    result = await response.json();
                    if (!livevueImgUpload && !checkOrder.variantId) {
                        localStorage.setItem('livevue_variantId', result.variantid)
                    }
                }
                var cartData = {
                    "id": result.variantid,
                    "properties": allProperties,
                    "quantity": document.querySelector('#livevue-Template [name="quantity"]').value
                };
                document.getElementById('larfloader').style.display = 'none';
                document.getElementById('newPreviewArea')?.remove();
                orderProcess(cartData, 'cart')
            }
        }
    }
} else if (pathSh == 'cart') {
    function updateCartLinks() {
        let image = localStorage.getItem('livevue_orderImage');
        let style = localStorage.getItem('livevue_frameStyles');
        let mat = localStorage.getItem('livevue_matStyles');
        if (document.getElementById('CartItem-1')?.children[0]?.children.length == 0) {
            let html_content = `<div class="cart-item__image-container gradient global-media-settings"><img src="${image}" class="cart-item__image" alt="New Product Image" loading="lazy" width="150" height="226"></div>`;
            document.getElementById('CartItem-1').children[0].insertAdjacentHTML('beforeend', html_content);
            let addedDiv = document.querySelector('.cart-item__image-container');
            if (addedDiv && style) {
                addedDiv.setAttribute('style', style);
                let computedStyle = window.getComputedStyle(addedDiv);
                addedDiv.style.borderWidth = `${parseFloat(computedStyle.borderWidth) / 4}px`;
                addedDiv.style.padding = `${parseFloat(computedStyle.padding) / 4}px`;
                addedDiv.style.borderColor = '';
            }
            let secMat = addedDiv.querySelector('img')
            if (secMat && mat) {
                secMat.setAttribute('style', mat);
                let computedStyle = window.getComputedStyle(secMat);
                secMat.style.padding = `${parseFloat(computedStyle.padding) / 4}px`;
            }
        }
        const cartPage_data = document.getElementsByClassName('cart-item');
        console.log("cart data; ",cartPage_data);
        fetch("/cart.json").then(response => response.json()).then(data => {
            data.items.forEach((eachItem, i) => {
                if (!eachItem.properties?._source) {
                    return;
                }
                let productUrl = eachItem.properties['_source'];
                if (
                    eachItem.product_title === "Frame Only" ||
                    productUrl.includes("/products/frame-only-130")
                ) {
                    productUrl = "/products/frame-only";
                }
                console.log("Cart product:", eachItem.product_title);
                console.log("Final product URL:", productUrl);
                // Find cart item
                const cartItem = cartPage_data[i];
                if (!cartItem) {
                    return;
                }
                // Update cart image link
                const imageLink = cartItem.querySelector('.cart-item__image-container' )?.closest('a');
                if (imageLink) {
                    imageLink.href = productUrl;
                }
                // Update ONLY cart title link
                const titleLink = cartItem.querySelector('.cart-item__title a');
                if (titleLink) {
                    titleLink.href = productUrl;
                    console.log("Updated cart title URL:",titleLink.href);
                }
            }); 
        })
        .catch(error => {
            console.error("Error fetching cart:", error);
        })
    }
    updateCartLinks();
    var cartContainer = document.querySelector('.cart__items');
    if (cartContainer) {
        const observer = new MutationObserver(updateCartLinks);
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
}
